import _styled from "@emotion/styled-base";

var getBgColor = function getBgColor(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      theme = _ref.theme;
  return theme.colors[type];
};

var getRadius = function getRadius(_ref2) {
  var circle = _ref2.circle,
      radius = _ref2.radius;
  return circle ? '50%' : typeof radius === 'number' ? radius + "px" : radius || '2em';
};

var small = function small(circle) {
  return "\n  " + (circle ? 'width: 1.3rem; height: 1.3rem; line-height: 1.25rem;' : 'padding: 2px 8px;') + "\n  font-size: .8em;\n";
};

var def = function def(circle) {
  return "\n    " + (circle ? 'width: 1.6rem; height: 1.6rem; line-height: 1.55rem;' : 'padding: 3px 12px;') + "\n  font-size: .9em;\n";
};

var medium = function medium(circle) {
  return "\n  " + (circle ? 'width: 2rem; height: 2rem; line-height: 1.95rem;' : 'padding: 6px 16px;') + "\n  font-size: .95em;\n";
};

var large = function large(circle) {
  return "\n  " + (circle ? 'width: 2.5rem; height: 2.5rem; line-height: 2.45rem;' : 'padding: 8px 20px;') + "\n  font-size: 1em;\n";
};

var getBySize = function getBySize(_ref3) {
  var size = _ref3.size,
      circle = _ref3.circle;

  switch (size) {
    case 'small':
      return small(circle);

    case 'medium':
      return medium(circle);

    case 'large':
      return large(circle);

    default:
      return def(circle);
  }
};

export var TagContainer = _styled("span", {
  target: "e1xh6qbp0"
})(getBySize, ";display:inline-block;text-align:", function (_ref4) {
  var circle = _ref4.circle;
  return circle ? 'center' : 'initial';
}, ";color:#f9f9f9;background-color:", getBgColor, ";border-radius:", getRadius, ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

if (typeof TagContainer !== 'undefined' && TagContainer && TagContainer === Object(TagContainer) && Object.isExtensible(TagContainer) && !Object.prototype.hasOwnProperty.call(TagContainer, '__filemeta')) {
  Object.defineProperty(TagContainer, '__filemeta', {
    configurable: true,
    value: {
      name: "TagContainer",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Tag/styles.js"
    }
  });
}